// src/pages/products/CoilsPage.tsx
import React from 'react';
import { Button, Modal, Input, Tag } from 'antd';
import { STORE_NAMES } from '../../utils/db';
import { IgnitionCoilItem } from '../../types/ProductItems';
import IgnitionCoilForm from '../../components/forms/IgnitionCoilForm';
import CoilsTable from '../../components/tables/CoilsTable';
import { useProductManager } from '../../hooks/useProductManager';

const CoilsPage: React.FC = () => {
  const [search, setSearch] = React.useState('');

  const {
    items: coils,
    currentItem,
    setCurrentItem,
    isModalVisible,
    setIsModalVisible,
    addItem: handleAddCoils,
    deleteItem: handleDelete,
    exportToExcel,
  } = useProductManager<IgnitionCoilItem>(STORE_NAMES.coils);

  const handleEdit = (item: IgnitionCoilItem) => {
    setCurrentItem(item);
    setIsModalVisible(true);
  };

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return coils;
    return coils.filter(item =>
      [item.brand, item.partNumber, item.model, item.original, String(item.price)]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q))
    );
  }, [coils, search]);

  const totalCount = coils.length;
  const shownCount = filtered.length;

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>

        <Button type="primary" onClick={() => { setIsModalVisible(true); setCurrentItem(null); }}>
          Добавить катушку зажигания
        </Button>

        <Button onClick={() => exportToExcel('Coils_Export')}>
          📁 Экспорт в Excel
        </Button>

        <Input
          placeholder="Поиск…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 280 }}
          allowClear
        />

        <Tag className="small-tag">Всего: {totalCount}</Tag>
        <Tag color="blue" className="small-tag">Показано: {shownCount}</Tag>

      </div>

      <CoilsTable data={filtered} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        title={currentItem ? 'Редактировать катушку зажигания' : 'Добавить катушку зажигания'}
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setCurrentItem(null); }}
        footer={null}
        destroyOnHidden
      >
        <IgnitionCoilForm onAdd={handleAddCoils} initialValues={currentItem} />
      </Modal>
    </div>
  );
};

export default CoilsPage;
